<style>
.t {
  /* min-height: calc(100vh - 84px - 180px); */
  height: fit-content;
}
</style>

<script>
import { cubicIn, cubicOut } from "svelte/easing";
import { fly } from "svelte/transition";

let { url, children } = $props();

const duration = 300;
const delay = duration + 100;
const y = 10;

const transitionIn = { easing: cubicOut, y, duration, delay };
const transitionOut = { easing: cubicIn, y: -y, duration };
</script>

{#key url}
  <div class="t h-[100vh] transition-all" in:fly={transitionIn} out:fly={transitionOut}>
    {@render children?.()}
  </div>
{/key}
